<template>
    <section class="reset-password flow__panel">
        <div class="reset-password__main">
            <h2 class="reset-password__title">
                Reset Password
            </h2>
            <div class="reset-password__text">
                You can use this screen to reset your password. Once you have done so you will be redirected to the login screen.
            </div>
            <hh-msg-display :message="message"
                            :type="msgType" />
            <hh-error-display :error="error" />
            <hh-form class="reset-password__form">
                <hh-form-group>
                    <hh-password def="newPassword"
                                 ref="model.NewPassword"
                                 class="reset-password__form__password"
                                 placeholder="Enter your new password"
                                 v-model="newPassword"
                                 @change="resetValidation" />
                    <hh-password def="confirmPassword"
                                 ref="model.ConfirmPassword"
                                 class="reset-password__form__password reset-password__form__password--confirm"
                                 placeholder="Enter your new password again"
                                 v-model="confirmPassword"
                                 @change="resetValidation" />
                </hh-form-group>
                <hh-btn type="cta"
                        class="reset-password__form__button reset-password__form__button--reset"
                        icon-class="fas fa-key"
                        icon-location="pre"
                        text="Reset Password"
                        @click="onResetPasswordClick" />
            </hh-form>
        </div>
    </section>
</template>

<script>

import ServiceFactory from '@/services/service-factory'

import AnalyticsPage from './analytics-page'

export default {

    mixins: [
        AnalyticsPage,
    ],

    data() {
        return {
            userId: this.$route.query.userId,
            resetCode: this.$route.query.code,
            newPassword: null,
            confirmPassword: null,
            error: null,
            message: null,
            msgType: 'default',
        }
    },

    methods: {

        _clearMessages() {
            this.message = null
            this.error = null
        },

        async _resetPassword() {
            try {
                const service = ServiceFactory.auth()
                const operationState = await service
                    .resetPasswordAsync(this.userId, this.resetCode, this.newPassword, this.confirmPassword)

                if (!operationState.succeeded) {
                    operationState.throw()
                } else {
                    this.$logger.log('Password reset accepted.')
                    this.$router.push({ name: 'LogIn' })
                }
            } catch (err) {
                this._resetPasswordFields()
                const validation = this.$serverValidator.bindResults(err, this.$refs)

                this.error = validation.allErrors.length
                    ? err.message.includes('status code 400')
                        ? `Reset failed: ${ validation.allErrors.join(', ') }`
                        : `Reset failed: ${ err.message } [${ validation.allErrors.join(', ') }]`
                    : `Reset failed: ${ err.message }`
            }
        },

        _resetPasswordFields() {
            this.newPassword = null
            this.$refs['model.NewPassword'].$el.childNodes[0].value = ''
            this.confirmPassword = null
            this.$refs['model.ConfirmPassword'].$el.childNodes[0].value = ''
        },

        async onResetPasswordClick() {
            await this._resetPassword()
        },

        resetValidation() {
            this.$serverValidator.clear(this.$refs)
            this._clearMessages()
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.

.reset-password {
    @include wizard-page;

    @include bp-min-mid {
        max-width: 80%;
    }

    @include bp-min-wide {
        max-width: 60%;
    }

    @include element('form') {

        @include element('password') {

            @include modifier('confirm') {
                margin-top: 0.2em;

                @include bp-min-small {
                    margin-top: 0;
                    margin-left: 1em;
                }

                @include bp-min-mid {
                    margin-left: 2em;
                }
            }
        }

        @include element('button') {
            margin-bottom: 0.5em !important;

            @include bp-min-small {
                margin-bottom: 0 !important;
            }

            @include modifier('ok') {
                float: right;

                @include bp-min-small {
                    margin-top: 80px;
                }
            }
        }
    }
}

</style>
